import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as Endpoints from "../../entities/Endpoints";
import axiosInstance from "../../services/axiosInstance";

const sendOfferEmailAPI = async (payload) => {

  try {
    const response = await axiosInstance.post(
      `${Endpoints.SEND_EMAIL}`, payload
    );
    return response.data;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

// Async thunk for sending an email
export const sendOfferEmail = createAsyncThunk(
  "email/sendEmail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await sendOfferEmailAPI(payload);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const emailSlice = createSlice({
  name: "leadOfferEmail",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
  },
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOfferEmail.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(sendOfferEmail.fulfilled, (state, action) => {
        state.isSuccess = true;
        state.isError = false;
        state.message =
          action.payload.message || "Email did not sent successfully";
      })
      .addCase(sendOfferEmail.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.payload || "Something went wrong!";
      });
  },
});

export const { resetState } = emailSlice.actions;
export default emailSlice.reducer;
